import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items = [] }) => (
    <nav aria-label="Breadcrumb" className="text-sm text-[#17252D]/70">
        <ol className="flex flex-wrap items-center gap-1">
            {items.map((item, idx) => {
                const isLast = idx === items.length - 1;
                return (
                    <li key={idx} className="flex items-center gap-1">
                        {item.to && !isLast ? (
                            <Link to={item.to} className="hover:text-[#001B3D]">{item.label}</Link>
                        ) : (
                            <span className={isLast ? "text-[#17252D]" : ""}>{item.label}</span>
                        )}
                        {!isLast && <ChevronRight className="h-3.5 w-3.5" />}
                    </li>
                );
            })}
        </ol>
    </nav>
);
